import { BadgeCheck, ShieldCheck, ReceiptText, Boxes, Headset, Map, Handshake, LayoutGrid } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const items = [
  { icon: BadgeCheck, title: "Productos originales", text: "Equipos 100% genuinos, sellados y con respaldo de marca." },
  { icon: ShieldCheck, title: "Garantía oficial", text: "Cobertura directa del fabricante en todo el país." },
  { icon: ReceiptText, title: "Facturación CFDI", text: "Facturación fiscal 4.0 en cada operación, sin excepción." },
  { icon: Boxes, title: "Compras por volumen", text: "Precios escalonados para pedidos corporativos." },
  { icon: Headset, title: "Atención personalizada", text: "Un asesor dedicado para cada cuenta empresarial." },
  { icon: Map, title: "Cobertura nacional", text: "Entregas en los 32 estados de la República." },
  { icon: Handshake, title: "Distribuidores autorizados", text: "Samsung, Syscom e Ingram Micro nos respaldan." },
  { icon: LayoutGrid, title: "Amplio catálogo", text: "Miles de productos en 15 categorías tecnológicas." },
];

export default function WhyEclick() {
  return (
    <section id="porque" className="relative py-24 md:py-36 bg-ecmist" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          num="02"
          chapter="¿Por qué eClick?"
          id="porque"
          title={<>Un socio comercial, <span className="text-ecamber">no solo un proveedor</span></>}
          sub="Ocho razones por las que cadenas de retail y empresas confían su abastecimiento tecnológico a eClick México."
        />
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((it, i) => (
            <Reveal key={it.title} delay={(i % 4) * 0.08}>
              <div className="card-lift h-full bg-white border border-ecnavy/10 rounded-2xl p-8 soft-shadow" data-testid={`why-card-${i}`}>
                <span className="icon-tile inline-flex h-12 w-12 rounded-xl bg-ecnavy text-white items-center justify-center mb-6">
                  <it.icon size={22} strokeWidth={2} />
                </span>
                <h3 className="font-display text-lg font-semibold text-ecdeep">{it.title}</h3>
                <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">{it.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
